import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Tabs' })({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    bar: {
        display: 'flex',
        alignItems: 'center'
    },
    item: {
        position: 'relative',
        padding: '16px 24px',
        borderRadius: '16px 16px 0 0',
        color: '#8E8E8E',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '24px',
        cursor: 'pointer'
    },
    _active: {
        background: '#F8F8F8',
        color: '#232323',
        fontSize: 16,
        fontWeight: 700,
        lineHeight: '24px'
    },
    corner: {
        position: 'absolute',
        color: '#F8F8F8',
        width: 16,
        height: 16
    },
    _bottomLeft: {
        bottom: 0,
        left: -16,
        transform: 'rotate(270deg)'
    },
    _bottomRight: {
        bottom: 0,
        right: -16
    }
});
